module.exports = __webpack_public_path__ + "static/media/historicalmarker.0573cc34.jpg";